import React, {useState} from 'react';
import {useNavigate} from 'react-router-dom';
import {FaMobileAlt, FaKey} from 'react-icons/fa';
import Post from './components/Post';
import AuthShell from './components/AuthShell';

const PostFree = () => {
  const navigate = useNavigate();

  const [mobile, setMobile] = useState('');
  const [password, setPassword] = useState('');
  const login = async () => {
    if (!mobile) {
      alert('Enter mobile number');
      return;
    }
    if (!password) {
      alert('Enter password');
      return;
    }

    try {
      const res = await Post.Login({mobile, password});
      if (res.error) {
        alert(res.errorMsg);
        return;
      }

      window.localStorage.setItem('user', JSON.stringify(res.data));
      window.localStorage.setItem('token', res.token);
      navigate('/home');
    } catch (err) {
      console.error('Login failed:', err);
      alert('Something went wrong, please try again.');
    }
  };
  return (
    <AuthShell title="Login">
      <form
        className="auth-form"
        onSubmit={event => {
          event.preventDefault();
          login();
        }}>
        <label className="auth-field">
          <FaMobileAlt className="auth-field-icon" size={20} />
          <input
            className="auth-input"
            type="tel"
            inputMode="numeric"
            autoComplete="tel"
            maxLength={10}
            placeholder="Mobile Number"
            value={mobile}
            onChange={event => setMobile(event.target.value)}
          />
        </label>

        <div className="auth-password-field">
          <label className="auth-field auth-field-with-action">
            <FaKey className="auth-field-icon" size={22} />
            <input
              className="auth-input"
              type="password"
              autoComplete="current-password"
              placeholder="Password"
              value={password}
              onChange={event => setPassword(event.target.value)}
            />
          </label>
          <button
            className="auth-inline-link"
            type="button"
            onClick={() => navigate('/forgot')}>
            Forgot?
          </button>
        </div>

        <button className="auth-submit" type="submit">
          Login
        </button>
      </form>

      <div className="auth-footer">
        <span>New to the app?</span>
        <button
          className="auth-link"
          type="button"
          onClick={() => navigate('/signup')}>
          Register
        </button>
      </div>
    </AuthShell>
  );
};

export default PostFree;
